<template>
  <app-card>
    <v-data-table
      :headers="headers"
      :items="employee.list"
      :loading="loading"
      mobile-breakpoint="0"
      hide-default-footer
    >
      <template v-slot:item.employeeNameTha="{ item }">
        <div>
          <a
            :href="`/history/empInfo/${item.employeeID}`"
            target="_blank"
            rel="opener"
          >
            {{ item.employeeNameTha }}
          </a>
        </div>
      </template>

      <template v-slot:item.hrPositionNumber="{ item }">
        <div>
          {{ item.hrPositionNumber }}
        </div>
      </template>

      <template v-slot:item.employeeTypeNameTha="{ item }">
        <div>
          {{ item.employeeTypeNameTha }}
        </div>
      </template>

      <template v-slot:item.positionNameTha="{ item }">
        <div>
          {{ item.positionNameTha }}
        </div>
      </template>

      <template v-slot:item.orgNameAllTha="{ item }">
        <div>
          {{ item.orgNameAllTha }}
        </div>
      </template>

      <template v-slot:item.workStatusNameTha="{ item }">
        <div>
          {{ item.workStatusNameTha }}
        </div>
      </template>

      <template v-slot:item.officePhone="{ item }">
        <div>
          {{ item.officePhone }}
        </div>
      </template>

      <template v-slot:footer>
        <div class="py-3">
          <v-pagination
            v-model="page"
            @input="onSearch"
            :length="employee.totalPage"
            :total-visible="7"
            style="justify-content: flex-end"
            circle
          />
        </div>
      </template>
    </v-data-table>
  </app-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,

      employee: {
        list: [],

        total: 0,

        totalPage: 0
      },

      page: 1
    }
  },

  computed: {
    headers() {
      return [
        {
          text: 'ชื่อ-สกุล',

          value: 'employeeNameTha',

          sortable: false,

          class: 'grey lighten-3'
        },

        {
          text: 'เลขที่อัตรา',

          value: 'hrPositionNumber',

          sortable: false,

          class: 'grey lighten-3'
        },

        {
          text: 'ประเภท',

          value: 'employeeTypeNameTha',

          sortable: false,

          class: 'grey lighten-3'
        },

        {
          text: 'ตำแหน่ง',

          value: 'positionNameTha',

          sortable: false,

          class: 'grey lighten-3'
        },

        {
          text: 'สังกัด',

          value: 'orgNameAllTha',

          sortable: false,

          class: 'grey lighten-3'
        },

        {
          text: 'สถานะ',

          value: 'workStatusNameTha',

          sortable: false,

          class: 'grey lighten-3'
        },

        {
          text: 'โทรศัพท์',

          value: 'officePhone',

          sortable: false,

          class: 'grey lighten-3'
        }
      ]
    }
  },

  watch: {
    $route() {
      this.setForm()
    }
  },

  async mounted() {
    this.setForm()
  },

  methods: {
    async apiGetEmpList(body) {
      this.loading = true

      let obj = { list: [], total: 0, totalPage: 0 }

      try {
        const res = await this.$store.dispatch('employee/postSearch', body)

        if (res) {
          obj.list = res.data?.data[0]?.items || []

          obj.total = res.data?.data[0]?.countemp || 0

          obj.totalPage = Math.ceil(parseInt(obj.total) / 10) || 0
        }

        return obj
      } catch (e) {
        console.log(e.response || e)

        return obj
      } finally {
        this.loading = false
      }
    },

    async setForm() {
      const noneKeyword =
        (!this.$route.query.organization01 ||
          this.$route.query.organization01 === '0') &&
        (!this.$route.query.SchName || this.$route.query.SchName === '0') &&
        (!this.$route.query.SchSurname ||
          this.$route.query.SchSurname === '0') &&
        (!this.$route.query.SchPersonal ||
          this.$route.query.SchPersonal === '0') &&
        (!this.$route.query.SchHRPosNumber ||
          this.$route.query.SchHRPosNumber === '0') &&
        (!this.$route.query.SchPositionName ||
          this.$route.query.SchPositionName === '0')

      if (!noneKeyword) {
        this.employee = await this.apiGetEmpList(this.$route.query)
      }

      this.page = 1
    },

    async onSearch() {
      const form = { ...this.$route.query, PageIndex: this.page - 1 }

      this.employee = await this.apiGetEmpList(form)
    }
  }
}
</script>

<style lang="scss" scoped></style>

